import React from 'react';
import { useParams } from 'react-router';
import { DashboardDetailsPage } from 'apps/sigma2-ui/src/pages/Dashboards/DashboardDetailsPage';
import { AccessGate } from 'apps/sigma2-ui/src/state/AccessGate';

export const DashboardAccessPage = () => {
  const { dashboardId } = useParams();

  if (!dashboardId) return null;

  return (
    <AccessGate
      resourceId={dashboardId}
      resourceType="dashboard"
      publicPath={(id) => `/embed/dashboards/${id}`}
      sharedPath={(id) => `/shared/dashboards/${id}`}
      authenticatedComponent={<DashboardDetailsPage />}
    />
  );
};
